export default {
  CATEGORY_LOADED: 'font/CATEGORY_LOADED',
  CATEGORY: 'font/CATEGORY',
  CATEGORY_FAILED: 'font/CATEGORY_FAILED',
  CATEGORIES_LOADED: 'font/CATEGORIES_LOADED',
  CATEGORIES_FAILED: 'font/CATEGORIES_FAILED',
  FONT_AUTOFILL_DATA_LOADED: 'font/FONT_AUTOFILL_DATA_LOADED',
  FONT_IS_CLICKED_FROM_DROPDOWN: 'font/FONT_IS_CLICKED_FROM_DROPDOWN',
  LOADING_RESULTS: 'font/LOADING_RESULTS',
  LOAD_FONT_SEARCH_HISTORY: 'font/LOAD_FONT_SEARCH_HISTORY',
  SET_SCROLL_TO_FONT: 'font/SET_SCROLL_TO_FONT',
  UPDATE_FONT_SEARCH_HISTORY: 'font/UPDATE_FONT_SEARCH_HISTORY',
  UPDATE_PREVIOUS_CATEGORY: 'font/UPDATE_PREVIOUS_CATEGORY'
};
